import React from "react";
import { Link } from "react-router-dom";
import "./not-found.css"

const NotFound = () => {
  return (
    <div className="page">
      <div className="not-found-page-wrapper">
        <h1>عفوا لاتوجد صفحة</h1>
        <Link className="not-found-link" to="/">الى الصفحة الرئيسية</Link>
      </div>
    </div>
  );
};

export default NotFound;
